export default "/images/c09aa3ab85f24c5e9b522175890b3d5f.avif";